import Link from '@components/common/Link/Link'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Media from '@components/ui/Media/Media'
import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import clsx, { default as cn } from 'clsx'
import { FC } from 'react'
import { UmbracoLink } from 'types/umbracoLink'
import styles from './StoriesPost.module.scss'
export type StoriesPostProps = {
  storiesTeaser?: string
  image?: MediaWithCropsFragment
  storiesTitle?: string
  linkTo?: UmbracoLink
  itemWidth?: number
  sliderItem?: boolean
  priority?: boolean
  category?: string[]
}

const StoriesPost: FC<StoriesPostProps> = ({
  storiesTeaser: teaser,
  storiesTitle: title,
  image,
  linkTo,
  itemWidth,
  sliderItem,
  priority,
  category,
}) => {
  const pageData = (
    <div className={styles.postWrapper}>
      <TrustedHtml className={styles.title} html={title} />

      {/* <div className={clsx(styles.title, 'headerTwo')}>
        {title.split(' ').map((word, index) => {
          const space = index === title.split(' ').length - 1 ? '' : ' '
          return (
            <span key={index}>
              {word}
              {space}
            </span>
          )
        })}
      </div> */}

      <div className={cn(styles.container, 'select-none')}>
        {image && (
          <div className={styles.imageContainer}>
            {teaser && (
              <div className={styles.imageOverlay}>
                <TrustedHtml html={teaser} className={styles.teaserText} />
              </div>
            )}
            <div className={styles.imageAspectRatio}>
              <div className={styles.image}>
                <Media
                  mediaWithCrops={image}
                  sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  mediaClassName={styles.image}
                  priority={priority}
                  disableShopTheLook
                />
              </div>
            </div>
          </div>
        )}
        <div className={styles.categoryWrapper}>
          {category &&
            category?.length > 0 &&
            category.map((cat, index) => (
              <div key={index} className={clsx(styles.category, 'bodyText')}>
                {cat}
              </div>
            ))}
        </div>
      </div>
    </div>
  )

  return linkTo ? (
    <Link link={linkTo} className={styles.item}>
      {pageData}
    </Link>
  ) : (
    pageData
  )
}

export default StoriesPost
